module.exports = __webpack_public_path__ + "static/media/dashboard.1cb303cc.svg";